import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChange,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { UtilService } from '../../../app/services/util.service';
import { AccountService } from '../../../app/services/account.service';
import { FormControl } from '@angular/forms';
import { GlobalValidators } from '../../utils/validators';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyEmailComponent implements OnChanges {
  @Input() email: string;
  @Output() verifyEmail = new EventEmitter<any>();
  sendVerificationCode;
  emailOtpSend;
  verifyingCodeInProgress;
  verifySignupErrors;
  emailVerified;
  emailVerifiedControl;
  otpCode = new FormControl('', GlobalValidators.required);

  constructor(private cdRef: ChangeDetectorRef, private utilService: UtilService, private accountService: AccountService) {}

  async ngOnChanges(changes: { [propKey: string]: SimpleChange }) {}

  sendOTPtoClient() {
    this.sendVerificationCode = true;
    this.accountService
      .sendEmailConfirmation({ email: this.email })
      .then((res) => {
        this.sendVerificationCode = false;
        this.emailOtpSend = true;
        this.cdRef.detectChanges();
        // console.log(res);
      })
      .catch((err) => {
        this.sendVerificationCode = false;
        this.cdRef.detectChanges();
        console.log(err);
      });
  }
  verifyEmailTrigger(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      document.getElementById('verifyEmailBtn').click();
    }
  }
  onVerifyEmail() {
    this.otpCode.markAsTouched();
    if (this.otpCode.invalid) {
      this.verifyingCodeInProgress = false;
      return;
    }
    this.verifyingCodeInProgress = true;
    this.verifySignupErrors = null;
    this.accountService
      .verifyEmailConfirmation({ email: this.email, verificationCode: this.otpCode.value })
      .then(() => {
        this.verifyingCodeInProgress = false;
        this.emailVerified = true;
        this.verifyEmail.emit(true);
        this.cdRef.detectChanges();
      })
      .catch((e) => {
        this.verifySignupErrors = ['Incorrect verification code'];
        this.verifyingCodeInProgress = false;
        this.cdRef.detectChanges();
      });
  }
}
